<div class="bc-chat-control-panel" [@slideInFromBottomAnimation]>
  <svg-icon icon="x" (click)="onTogglePanelClick()" class="icon-close" id="toggle-chat-more-actions"></svg-icon>

  <div class="container-fluid">
    <div class="control-panel-groups">
      <div *ngIf="hasSendGroupPanelItem()" class="control-panel-group control-panel-group-send">
        <a *ngIf="hasWrapUps" (click)="onWrapUpClick()" class="btn btn-light" id="chat-wrap-up-button">
          <span>{{ 'chatWorkWidget.wrapUp' | translate }}</span>
        </a>
      </div>
      <div [ngClass]="hasSendGroupPanelItem() ? 'control-panel-group control-panel-group-action' : 'single-control-panel-group'">
        <a (click)="onTransferClick()" class="btn btn-light" id="chat-transfer-button">
          <span>{{ 'chatWorkWidget.transfer' | translate }}</span>
        </a>
        <a (click)="onEndChatClick()" class="btn btn-light" id="chat-end-button">
          <span>{{ 'chatWorkWidget.endChat' | translate }}</span>
        </a>
      </div>
    </div>
  </div>
</div>
